import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class IsicCardService {
    constructor(@Inject('ENV') private env: any, private http: HttpClient) {}
    
    activateIsicCard(payload): Observable<any> {
        payload['region_id'] = this.env.REGION_ID;
        const code = payload['personal_code'];
        const url = `${this.env.API_BASE_URL}/isic/regions/${this.env.REGION_ID}/tickets/isic/${code}`;
        return this.http.put(url, payload);
    }
}